import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class DeleteUserAlertUseCase extends UseCase {
  constructor({repository, getCurrentUserService}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'DeleteUserAlertUseCase#execute'})
  @inlineError
  async execute({alertId}) {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()

    const [error, response] = await this._repository.deleteUserAlert({
      userId,
      alertId
    })
    if (error) return Promise.reject(error)

    return response
  }
}

export default DeleteUserAlertUseCase
